import React from "react";
import { jsx } from "slate-hyperscript";
import {
    BlockHandler, ElementType, InlineHandler, StyleType, TextElement,
} from "./base";

BlockHandler.register(ElementType.PARAGRAPH, {
    nodeTypes: ["P"],
    toBlock: child => child,
    serialize: child => `<p>${child}</p>`,
    deserialize: children => jsx("element", { type: ElementType.PARAGRAPH }, children),

});

InlineHandler.register(StyleType.NEW_LINE, {
    nodeTypes: ["BR"],
    toBlock: () => <br />,
    serialize: () => `<br />`,
    deserialize: () => ({ text: "" }) as TextElement,
});

BlockHandler.registerNodeHandler({
    nodeTypes: ["BODY"],
    // deserialize: children => jsx("fragment", {}, children.filter(SlateElement.isElement)),
    deserialize: children => jsx("fragment", {}, children),
});
